import React from 'react'
import {
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Stack,
    Text,
    useStyleConfig,
    Radio,
    RadioGroup,
    Flex,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useAccordionItemState} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import {PlusIcon, MinusIcon} from '../../../components/icons'
import {useGoogleTagManager} from '../../../custom-api/hooks/use-google-tag-manager'
import {basic_gtm_event} from '../../../custom-api/layers/default'
import {remCalc} from '../../../theme/_utils'

const SortByAccordionItem = ({
    selectedSortingOptionLabel,
    sortUrls,
    productSearchResult,
    onSelect,
}) => {
    const {formatMessage} = useIntl()
    const history = useHistory()
    const style = useStyleConfig('SortByAccordionItem')
    const [value, setValue] = React.useState(selectedSortingOptionLabel?.label)
    const {addLayer} = useGoogleTagManager()

    const handleChange = (newValue) => {
        const selectedOption = productSearchResult?.sortingOptions.find(
            (option) => option.label === newValue,
        )
        const selectedUrl = sortUrls[productSearchResult?.sortingOptions.indexOf(selectedOption)]
        addLayer(
            basic_gtm_event.bind(this, {
                event: 'ga_event',
                event_name: 'engagement',
                eventCategory: 'Sort',
                eventAction: 'filter_apply',
                eventLabel: selectedOption?.label || selectedOption?.id || '',
            }),
        )

        setValue(newValue)
        history.push(selectedUrl)
        onSelect()
    }

    const AccordionChevron = () => {
        const {isOpen} = useAccordionItemState()
        return isOpen ? (
            <Flex paddingY="xxsmall.base" paddingX="xxsmall.lg">
                <MinusIcon
                    width={remCalc(10.8)}
                    height={remCalc(10.8)}
                    color="foreground.neutral.subtle"
                />
            </Flex>
        ) : (
            <Flex paddingY="xxsmall.base" paddingX="xxsmall.lg">
                <PlusIcon
                    width={remCalc(10.8)}
                    height={remCalc(10.8)}
                    color="foreground.neutral.default"
                />
            </Flex>
        )
    }
    return (
        <AccordionItem key="show-all" {...style.accordionItem}>
            <AccordionButton {...style?.button}>
                <Text {...style?.headerTextAccordion}>
                    {formatMessage(
                        {
                            id: 'sort_accordion.button.sort_by',
                            defaultMessage: 'Sort by',
                        },
                        {
                            sortOption: selectedSortingOptionLabel?.label,
                        },
                    )}
                </Text>
                <AccordionChevron />
            </AccordionButton>
            <AccordionPanel {...style?.panel}>
                <RadioGroup onChange={handleChange} value={value}>
                    <Stack {...style?.stack} spacing={1}>
                        {productSearchResult?.sortingOptions?.map((option, idx) => (
                            <Flex
                                {...style?.item}
                                key={idx}
                                justifyContent="flex-start"
                                gap={remCalc(6)}
                            >
                                <Radio {...style?.radioDrawer} value={option.label} />
                                <Text {...style?.text} padding={0}>
                                    {option.label}
                                </Text>
                            </Flex>
                        ))}
                    </Stack>
                </RadioGroup>
            </AccordionPanel>
        </AccordionItem>
    )
}

SortByAccordionItem.propTypes = {
    selectedSortingOptionLabel: PropTypes.shape({
        label: PropTypes.string,
    }),
    sortUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
    productSearchResult: PropTypes.shape({
        sortingOptions: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
            }),
        ),
    }),
    onSelect: PropTypes.func,
}

export default SortByAccordionItem
